<template>
  <!-- <div class="pb-1"> -->
  <!-- <div class="alert alert-dismissible alert-danger mb-3"> -->
  <p class="small mb-2">
    Alle velden met
    <span class="required">*</span> zijn verplicht.
  </p>
  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
export default {};
</script>

<style scoped></style>
